module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_10-00f9cde53fe5ccb3c89c6024686e1fd8.jpg";